/* tslint:disable */
/* eslint-disable */
/**
 * WeighMed Backend APIs - OpenAPI 3.0
 * You can find out more about Swagger at [https://editor.swagger.io/](https://editor.swagger.io/).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VQueryTanksRequestParams
 */
export interface VQueryTanksRequestParams {
    /**
     * Clinic Id
     * @type {string}
     * @memberof VQueryTanksRequestParams
     */
    clinicId: string;
}

/**
 * Check if a given object implements the VQueryTanksRequestParams interface.
 */
export function instanceOfVQueryTanksRequestParams(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clinicId" in value;

    return isInstance;
}

export function VQueryTanksRequestParamsFromJSON(json: any): VQueryTanksRequestParams {
    return VQueryTanksRequestParamsFromJSONTyped(json, false);
}

export function VQueryTanksRequestParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): VQueryTanksRequestParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clinicId': json['clinicId'],
    };
}

export function VQueryTanksRequestParamsToJSON(value?: VQueryTanksRequestParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'clinicId': value.clinicId,
    };
}

